import { ViewMedicaVideoPlayer } from '@/components/ViewMedicaVideoPlayer';
import { YouTubeVideoPlayer } from '@/components/YouTubeVideoPlayer';
import { VimeoVideoPlayer } from '@/components/VimeoVideoPlayer';
import { Video, VideoWrapper } from './styles';

interface VideoSectionPros {
  title: string;
  videoId: string;
  hosting: string;
}

export function VideoSection({
  videoId,
  hosting,
  title,
}: VideoSectionPros): JSX.Element {
  const height = 522;
  const width = 925;
  const ratio = (height * 100) / width;

  let player;
  switch (hosting) {
    case 'vimeo':
      player = VimeoVideoPlayer;
      break;
    case 'viewmedica':
      player = ViewMedicaVideoPlayer;
      break;
    case 'youtube':
      player = YouTubeVideoPlayer;
      break;
  }

  return (
    <VideoWrapper ratio={ratio}>
      <Video
        as={player}
        videoId={videoId}
        title={title}
        width={width}
        height={height}
      />
    </VideoWrapper>
  );
}
